export const linkHoverClassNames = 'hover:underline hover:underline-offset-2 hover:text-orange-500';
